import { render, staticRenderFns } from "./TurnServer.vue?vue&type=template&id=afbbb79e&scoped=true"
import script from "./TurnServer.vue?vue&type=script&lang=js"
export * from "./TurnServer.vue?vue&type=script&lang=js"
import style0 from "./TurnServer.vue?vue&type=style&index=0&id=afbbb79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbbb79e",
  null
  
)

export default component.exports